import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { P00062InstallationFinish } from './P00062/Installation/P00062InstallationFinish';
import { P00062InstallationReset } from './P00062/Installation/P00062InstallationReset';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00062ChauffageMiseEnOeuvreInit } from './P00062/Chauffage/miseenoeuvre/P00062ChauffageMiseEnOeuvreInit';
import { P00062InstallationIdentificationPacPolyComponent } from './P00062/Installation/p00062-installation-identification-pac-poly/p00062-installation-identification-pac-poly.component';
import { P00062InstallationPositionPacPolyComponent } from './P00062/Installation/p00062-installation-position-pac-poly/p00062-installation-position-pac-poly.component';
import { P00062CardChauffageControleComponent } from './P00062/Chauffage/cards/p00062-card-chauffage-controle/p00062-card-chauffage-controle.component';
import { P00062CardChauffageStatutComponent } from './P00062/Chauffage/cards/p00062-card-chauffage-statut/p00062-card-chauffage-statut.component';
import { P00062Alarm } from './P00062/Alarm/P00062Alarm';
import { P00043Alarm } from './P00043/Alarm/P00043Alarm';
import { P00062ChauffageMiseEnOeuvreProgrammationComponent } from './P00062/Chauffage/miseenoeuvre/p00062-chauffage-mise-en-oeuvre-programmation/p00062-chauffage-mise-en-oeuvre-programmation.component';
import { P00062ChauffageMiseEnOeuvreFiltrationComponent } from './P00062/Chauffage/miseenoeuvre/p00062-chauffage-mise-en-oeuvre-filtration/p00062-chauffage-mise-en-oeuvre-filtration.component';
import { P00062ChauffageMiseEnOeuvrePacComponent } from './P00062/Chauffage/miseenoeuvre/p00062-chauffage-mise-en-oeuvre-pac/p00062-chauffage-mise-en-oeuvre-pac.component';
import { P00062ChauffageControleComponent } from './P00062/Chauffage/cps/p00062-chauffage-controle/p00062-chauffage-controle.component';
import { P00062ChauffageParametersComponent } from './P00062/Chauffage/cps/p00062-chauffage-parameters/p00062-chauffage-parameters.component';
import { P00062ChauffageStatutComponent } from './P00062/Chauffage/cps/p00062-chauffage-statut/p00062-chauffage-statut.component';

export class P00062Data {
  ppCModeFonctionnement: number = 0;

  ppCResetUsine: number = 0;

  ppCConfirmationOTA: number = 0;

  ppIActivationFonctionPriorite: number = 0;

  ppIActivationFonctionAutoMaintien: number = 0;

  ppIConfigurationProduit: number = 0;

  ppISourceVolet: number = 0;

  ppISourceTemperature: number = 0;

  ppPModeFonctionnementTemperature: number = 0;

  ppPModeFonctionnementRegulation: number = 0;

  ppPTemperatureConsigne: number = 0;

  ppPTypeHorloge: number = 0;

  ppPHorlogeSemaine: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourLundi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourMardi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourMercredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourJeudi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourVendredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourSamedi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppPHorlogeJourDimanche: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  ppSEtatFonctionnementPAC: number = 0;

  ppSCommandeHorloge: number = 0;

  ppSMiseRouteFiltrationPriorite: number = 0;

  ppSMiseRouteFiltrationAutoMaintien: number = 0;

  ppSEtatVolet: number = 0;

  ppSDIsponibiliteEtatVolet: number = 0;

  ppSRecommandationFermetture: number = 0;

  ppSAlarme: number = 0;

  ppSEtatSysteme: number = 0;

  ppSEtatBouton: number = 0;

  ppSDisponibiliteTemperatureEau: number = 0;

  ppSModeRegistreCommande: number = 0;

  ppSCompensationTemperature: number = 0;

  ppSTemperatureEauEntrante: number = 0;

  ppSTemperatureEauSortante: number = 0;

  ppSMesureTemperatureEau: number = 0;

  ppSTemperatureConsigneHorloge: number = 0;

  ppSBypassPac: number = 0;

  ppSCompteurResetUsine: number = 0;

  ppSTempsSousTension: number = 0;

  ppSTensionAlimentation: number = 0;

  ppSCourantConsomme: number = 0;

  ppSPuissanceActive: number = 0;

  ppSCompteurPuissanceActiveTotale: number = 0;

  ppSDefaut1: number = 0;

  ppSDefaut2: number = 0;

  ppSDefaut3: number = 0;

  ppSDefaut4: number = 0;

  ppSTemperatureDecharge: number = 0;

  ppSTemperatureAspiration: number = 0;

  ppSTemperatureBobine: number = 0;

  ppSTemperatureAirAmbiant: number = 0;

  ppSTemperatureIPM: number = 0;

  ppSCompteurBouton: number = 0;
}

export class P00062 extends IProduct {
  override deviceTableIndex: number = 26;

  override modelIdentifier?: string = 'P00062';

  override dataIdentifier?: string = 'P00062';

  override manufacturerName?: string = 'ACWA';

  data: P00062Data = new P00062Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00062/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00062/product_light.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00062/product_light.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00062;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00062?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00062.tuto.installation.help.title',
      helpSlides: [
        'P00062.tuto.installation.help.1',
        'P00062.tuto.installation.help.2',
        'P00062.tuto.installation.help.3',
        'P00062.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00062/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P00062/installation-1_dark.png',
          },
          text: 'P00062.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00062/installation-2_light.png',
            dark: '/assets/ecosystem/images/products/P00062/installation-2_dark.png',
          },
          text: 'P00062.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00062/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P00062/installation-1_dark.png',
          },
          text: 'P00062.tuto.update.page1',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00062InstallationIdentificationPacPolyComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00062InstallationPositionPacPolyComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00062InstallationFinish,
        reset: P00062InstallationReset,
      },

      alarms: {
        weight: 21,
        component: P00062Alarm,
      },

      controlCards: [
        { component: P00062CardChauffageControleComponent, weight: 11 },
      ],

      statusCards: [
        { component: P00062CardChauffageStatutComponent, weight: 21 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.PAC];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.PAC ||
      functionnality == EventProductFunctionnalityEnum.PAC
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00062ChauffageMiseEnOeuvreProgrammationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00062ChauffageMiseEnOeuvreFiltrationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00062ChauffageMiseEnOeuvrePacComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P00062ChauffageMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00062ChauffageControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00062ChauffageParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00062ChauffageStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00062.status.pilotagePAC',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 639,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'ppSEtatFonctionnementPAC',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00062.status.temperatureEau',
                mode: HistoryGraphModeEnum.DATA,
                property: 'ppSTemperatureEauEntrante',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 450 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: false,
              },
              {
                title: 'P00062.status.consigneTemp',
                mode: HistoryGraphModeEnum.DATA,
                property: 'ppPTemperatureConsigne',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 400 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: false,
              },
              {
                title: 'P00062.status.tension',
                mode: HistoryGraphModeEnum.DATA,
                property: 'ppSCompteurPuissanceActiveTotale',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 12700 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.PACPOLY_Controle,
      propertyName: 'ppCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).ppIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
